import {memo} from 'react';

import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';
import {Skeleton} from '~/shared/components/Loaders';

import {Title} from '../shared';

import FilterSelection from './FilterSelection';
import {Root} from './styled';
import CustomTable from './CustomTable/CustomTable';

const TransactionTableWrapper = styled.div`
  z-index: 3;
`;
const DesktopTransactionTable = ({
  columns,
  filter,
  onFilterChange,
  allPayments,
  visibleItems,
  openRows,
  toggleRow,
  getCssClasses,
  menuEvents,
  dataTestId,
  checkIfMoneycardIsCredit,
  hideTitle,
  hideFilters,
  withRoundedCorners,
  tableHeaderCustomColor,
  customTableFooterColor,
}) => {
  const {t} = getLocalizationService();

  return (
    <Root>
      {!hideTitle && <Title as="h4">{t('transaction_report')}</Title>}
      <>
        {!hideFilters && (
          <FilterSelection
            value={filter}
            placeholder={t('all_payment_options')}
            filterOptions={allPayments}
            onFilterChange={onFilterChange}
            top={-4}
            checkIfMoneycardIsCredit={checkIfMoneycardIsCredit}
          />
        )}
        <TransactionTableWrapper>
          <CustomTable
            columns={columns}
            rows={visibleItems}
            toggleRow={toggleRow}
            menuEvents={menuEvents}
            skeletonComponent={<Skeleton width={100} height={24} />}
            withSeperators
            isTransactionTable
            getCssClasses={getCssClasses}
            openRows={openRows}
            summary={t('transaction_table_summary')}
            rowDataTestId={dataTestId}
            withRoundedCorners={withRoundedCorners}
            tableHeaderCustomColor={tableHeaderCustomColor}
            customTableFooterColor={customTableFooterColor}
          />
        </TransactionTableWrapper>
      </>
    </Root>
  );
};
export default memo(DesktopTransactionTable);
